module.exports = __webpack_public_path__ + "img/20200514_150253.0d09de61.jpg";